import { createAction } from '@ngrx/store'

const SOURCE = '[Command Palette]'

export const openCommandPalette = createAction(`${ SOURCE } Open`)

export const closeCommandPalette = createAction(`${ SOURCE } Close`)

export const toggleCommandPalette = createAction(`${ SOURCE } Toggle`)